import { gql } from '@apollo/client';

import PAYMENT_EXCHANGE_PAYMENT from './PAYMENT_EXCHANGE_PAYMENT';

export default gql`
  query booking($reference: String!, $currency: Currency) {
    booking(reference: $reference) {
      additionalDetails {
        value
        key
        itemRef
      }
      reference
      status
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      customer {
        firstName
        lastName
        email
        phoneNumber
        address {
          street
          postalCode
          city
          countryCode
        }
      }
      payments(onlyProvisional: true) {
        ...PaymentExchangePayment
      }
      changeExpiryTimestamp
      amountDue: amountDueWithCurrency(currency: $currency) {
        amount
        currency
      }
      onHold: onHoldWithCurrency(currency: $currency) {
        depositAmount
      }
      isPackage
      isLoyalty
      hotels {
        itemRef
      }
    }
  }

  ${PAYMENT_EXCHANGE_PAYMENT}
`;
